import axios from "axios";
import { commonApi } from "../common/constants"; 

export async function applyNewMembership(formData, certificateFile) {
  try {
    const tokenUrl = `${commonApi}membership/get-token`;
    console.log("Fetching token from: ", tokenUrl);
    
    const tokenResponse = await axios.get(tokenUrl);
    
    if (!tokenResponse.data || !tokenResponse.data.success) {
        return { success: false, message: "Failed to generate security token. Please try again." };
    }
    
    const token = String(tokenResponse.data.data.token);
    console.log("Token generated:", token);

    const apiUrl = `${commonApi}membership/apply_new_membership`;
    console.log("Submitting to Api Url: ", apiUrl);

    const apiPayload = {
      name: formData.fullName || "",
      dateOfBirth: formData.dob ? new Date(formData.dob).toISOString() : "",
      gender: formData.gender || "",
      designation: formData.designation || "",
      institution: formData.institution || "",
      officeAddress: formData.officeAddress || "",
      residentialAddress: formData.residentialAddress || "",
      emailId: formData.email || "",
      phoneNumber: formData.mobile || "",
      qualification: formData.qualifications || "",
      mciRegNo: formData.medicalCouncilNo || "",
      areaOfInterest: formData.areaOfInterest || "", 
      membershipCat: formData.membershipCategory || "",
      paidAmount: String(formData.paidAmount || ""), 
      paymentMode: formData.paymentMode || "",
      utrNumber: formData.paymentMode === 'Cash' ? "" : (formData.utrNumber || ""), 
      paymentDate: formData.paymentDate ? new Date(formData.paymentDate).toISOString() : new Date().toISOString(),
      status: "Applied",
      canReferOther: false
    };

    const submitData = new FormData();
    submitData.append("member", JSON.stringify(apiPayload)); 
    submitData.append("file", certificateFile);
    submitData.append("token", token);

    const response = await axios.post(apiUrl, submitData);
    
    console.log("Raw Response String:", JSON.stringify(response.data));
    
    if (response.data && response.data.success === false) {
        return { 
            success: false, 
            message: response.data.message || "Submission failed.", 
            data: response.data 
        };
    }
    
    return { 
      success: true, 
      message: response.data.message || "Application submitted successfully!", 
      data: response.data 
    };

  } catch (error) {
    console.error("Network/API error:", error);
    
    let errorMessage = "Network error";

    if (error.response && error.response.status === 422) {
        const resData = error.response.data;
        
        if (resData.detail && Array.isArray(resData.detail)) {
            const errorDetails = resData.detail.map(err => {
                const fieldName = err.loc[err.loc.length - 1]; 
                return `${fieldName}: ${err.msg}`;
            }).join(' | ');
            errorMessage = `Validation Failed -> ${errorDetails}`;
        } 
        else if (resData.errors && typeof resData.errors === 'object') {
            const errorDetails = Object.entries(resData.errors)
                .map(([field, msgs]) => `${field}: ${Array.isArray(msgs) ? msgs.join(', ') : msgs}`)
                .join(' | ');
            errorMessage = `Validation Failed - ${errorDetails}`;
        } 
        else if (resData.message) {
            errorMessage = `Validation Failed - ${resData.message}`;
        } else {
            errorMessage = "Validation Failed: Please check your input fields.";
        }
    } else {
        errorMessage = error.response?.data?.message || error.message || "Network error";
    }

    return { 
      success: false, 
      message: errorMessage, 
      data: null 
    };
  }
}